import Model from '@/components/Cards/FlipCard/model.js'

class Solicitation {
    constructor() {
        this.datetime_created = ''
        this.id = null
        this.branch = ''
        this.request_user = {}
        this.response_user = ''
        this.total_items = ''
        this.status = ''
        this.note = ''
        this.response = ''
    }

    static get fieldNames() {
        return {
            datetime_created: 'Data',
            id: 'ID',
            branch: 'Filial',
            request_user: 'Requerente',
            response_user: 'Atendente',
            total_items: 'Total de Itens',
            status: 'Status'
        }
    }

    static get fieldTypes() {
        return {
            datetime_created: 'datetime-local',
            id: 'number',
            branch: 'number',
            request_user: 'Object',
            response_user: 'text',
            total_items: 'number',
            status: 'text'
        }
    }

    static get visibleFields() {
        return {
            datetime_created: true,
            id: true,
            branch: true,
            request_user: true,
            response_user: true,
            total_items: true,
            status: true
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            // datetime_created: false,
            // datetime_updated: false
        }
    }

    static get fieldNamesExtraProduct() {
        return {
            quantity: 'Quantidade',
            branch_origin: 'CD de atendimento',
            reason: 'Motivo',
            response: 'Resposta',
            note: 'Observação',
            status: 'Status'
        }
    }

    static get fieldTypesExtraProduct() {
        return {
            quantity: 'number',
            branch_origin: 'text',
            reason: 'text',
            response: 'text',
            note: 'textarea',
            status: 'text'
        }
    }

    static get editableFieldsExtraProduct() {
        return {
            quantity: true,
            branch_origin: true,
            reason: true,
            response: true,
            note: true,
            status: true
        }
    }

    static get fieldNamesAssortmentParameter() {
        return {
            stack_items: 'Peças na pilha',
            showcase_items: 'Peças no mostruário',
            coverage: 'Tempo de Cobertura',
            stock_max: 'Estoque máximo',
            note: 'Observação',
            status: 'Status'
        }
    }

    static get fieldTypesAssortmentParameter() {
        return {
            stack_items: 'number',
            showcase_items: 'number',
            coverage: 'number',
            stock_max: 'number',
            note: 'textarea',
            status: 'text'
        }
    }

    static get editableFieldsAssortmentParameter() {
        return {
            stack_items: true,
            showcase_items: true,
            coverage: true,
            stock_max: true,
            note: true,
            status: true
        }
    }

    static get fieldNamesAssortmentProductAdd() {
        return {
            branch_origin: 'Filial',
            product_extermal_id_description: 'Produto',
            product_common_cod: 'Código comum do produto',
            product_color: 'Cor',
            product_voltage: 'Voltagem',
            note: 'Observação',
            status: 'Status'
        }
    }

    static get fieldTypesAssortmentProductAdd() {
        return {
            branch_origin: 'text',
            product_extermal_id_description: 'text',
            product_common_cod: 'text',
            product_color: 'text',
            product_voltage: 'text',
            note: 'textarea',
            status: 'text'
        }
    }

    static get editableFieldsAssortmentProductAdd() {
        return {
            branch_origin: false,
            product_extermal_id_description: false,
            product_common_cod: true,
            product_color: true,
            product_voltage: true,
            note: true,
            status: true
        }
    }

    static field(head, subHead) {
        return { head, subHead }
    }

    static get productField() {
        return this.field('Produto', { productId: 'ID', productName: 'Descrição', productCurve: 'Classificação' })
    }

    static get noteField() {
        return this.field('Observação', { note: '-' })
    }

    static get responseField() {
        return this.field('Resposta', { response: '-' })
    }

    static get statusField() {
        return this.field('Status', { status: '-' })
    }

    static get storeCoverage() {
        return this.field(
            'Tempo de Cobertura - Loja (Most + Pilha)',
            {
                currentCoverage: 'Atual',
                requestedStoreCoverage: 'Solicitado',
                approvedStoreCoverage: 'Atendido',
                coverageLimit: 'TC Limite',
            }
        )
    }

    static requestedAndApprovedFields(head, requestedKey = 'requested', approvedKey = 'approved') {
        let subHead = {}
        subHead[requestedKey] = 'Solicitado'
        subHead[approvedKey] = 'Atendido'
        return this.field(head, subHead)
    }

    static get assortmentParameterFields() {
        return {
            product: this.productField,
            stack_items: this.requestedAndApprovedFields('Pilha', 'requestedStack', 'approvedStack'),
            showcase_items: this.requestedAndApprovedFields('Mostruário', 'requestedShowcase', 'approvedShowcase'),
            coverage: this.requestedAndApprovedFields('Ciclo', 'requestedCoverage', 'approvedCoverage'),
            stock_max: this.requestedAndApprovedFields('Estoque Máximo', 'requestedStockMax', 'approvedStockMax'),
            storeCoverage: this.storeCoverage,
            note: this.noteField,
            response: this.responseField,
            status: this.statusField
        }
    }

    static get extraProductFields() {
        return {
            product: this.productField,
            request_body: this.requestedAndApprovedFields('Pedido'),
            reason: this.field('Motivo', { reason: '-' }),
            note: this.noteField,
            response: this.responseField,
            status: this.statusField
        }
    }

    static get changeAmplitudeFields() {
        return {
            tree: this.field('Filtro da Árvore', { tree: '-' }),
            quantity: this.requestedAndApprovedFields('Quantidade'),
            note: this.noteField,
            // response: this.responseField,
            status: this.statusField
        }
    }

    static get changeAssortmentFields() {
        return {
            product: this.productField,
            action: this.field('Ação', { action: '-' }),
            note: this.noteField,
            response: this.responseField,
            status: this.statusField
        }
    }

    static get favoriteProductsFields() {
        const { response, ...rest } = this.changeAssortmentFields
        return rest
    }

    static dCOverview() {
        return {
            name: 'Visão do CD',
            subTitles: {
                TOTAL_STOCK: 'Total',
                RESERVED_STOCK: 'Reservado',
                NET_STOCK: 'Disponível',
            }
        }
    }

    static branchOverview() {
        return {
            name: 'Visão da Loja',
            subTitles: {
                TOTAL_STOCK: 'Estoque',
                TOTAL_TRAFFIC: 'Trânsito',
                TOTAL_SOLICITATION: 'Pedido',
                RESERVED_STOCK: 'Reservado'
            }
        }
    }

    static cardTitles() {
        return {
            EXTRA_PRODUCT: {
                SOLICITATION: {
                    name: 'Pedido',
                    subTitles: {
                        REQUESTED_QUANTITY: 'Qtd Solicitada',
                        APPROVED_QUANTITY: 'Qtd Atendida',
                        REASON: 'Motivo',
                        NOTE: 'OBS'
                    }
                },
                DC_OVERVIEW: this.dCOverview(),
                BRANCH_OVERVIEW: this.branchOverview(),
                RESTOCKING: {
                    name: 'Rep. Dinâmica',
                    subTitles: {
                        SHOWCASE_ITEMS: 'Mostruário',
                        STACK_ITEMS: 'Pilha',
                        COVERAGE: 'Dias de Estoque',
                        STOCK_MAX: 'Est. Máximo',
                        CONSIDERED_STOCK: 'P. Pedido',
                        HAS_RESTOCKING: 'Reposição'
                    }
                }
            },
            RESTOCKING_MANAGEMENT: {
                SOLICITATION: {
                    name: 'Parâmetros',
                    subTitles: {
                        SHOWCASE_ITEMS: 'Mostruário',
                        STACK_ITEMS: 'Pilha',
                        COVERAGE: 'Dias de Estoque',
                        STOCK_MAX: 'Est. Máximo'
                    }
                },
                DC_OVERVIEW: this.dCOverview(),
                BRANCH_OVERVIEW: this.branchOverview(),
                DYNAMIC_MINIMUM: {
                    name: 'Min. Dinâmico',
                    subTitles: {
                        QUANTITY: 'Quantidade',
                        DAYS: 'Dias'
                    }
                }
            }
        }
    }

    static extraProductCard() {
        const { SOLICITATION, DC_OVERVIEW, BRANCH_OVERVIEW, RESTOCKING } = this.cardTitles().EXTRA_PRODUCT
        const card = new Model('Produto Extra')

        card.addItem('solicitation', SOLICITATION.name, [
            { name: SOLICITATION.subTitles.REQUESTED_QUANTITY, key: 'requestedQuantity' },
            { name: SOLICITATION.subTitles.APPROVED_QUANTITY, key: 'approvedQuantity' },
            { name: SOLICITATION.subTitles.REASON, key: 'reason' },
            { name: SOLICITATION.subTitles.NOTE, key: 'note' },
        ])

        card.addItem('dcOverview', DC_OVERVIEW.name, [
            { name: DC_OVERVIEW.subTitles.TOTAL_STOCK, key: 'total_stock' },
            { name: DC_OVERVIEW.subTitles.RESERVED_STOCK, key: 'reserved_stock' },
            { name: DC_OVERVIEW.subTitles.NET_STOCK, key: 'net_stock' },
            { name: DC_OVERVIEW.subTitles.TOTAL_STOCK, key: 'total_solicitation' },
            { name: DC_OVERVIEW.subTitles.RESERVED_STOCK, key: 'reserved_solicitation' },
            { name: DC_OVERVIEW.subTitles.NET_STOCK, key: 'net_solicitation' },
        ])

        card.addItem('branchOverview', BRANCH_OVERVIEW.name, [
            { name: BRANCH_OVERVIEW.subTitles.TOTAL_STOCK, key: 'total_stock' },
            { name: BRANCH_OVERVIEW.subTitles.TOTAL_TRAFFIC, key: 'total_traffic' },
            { name: BRANCH_OVERVIEW.subTitles.TOTAL_SOLICITATION, key: 'total_solicitation' },
            { name: BRANCH_OVERVIEW.subTitles.RESERVED_STOCK, key: 'reserved_value' },
        ])

        card.addItem('dynamicReplacement', RESTOCKING.name, [
            { name: RESTOCKING.subTitles.SHOWCASE_ITEMS, key: 'showcase_items' },
            { name: RESTOCKING.subTitles.STACK_ITEMS, key: 'stack_items' },
            { name: RESTOCKING.subTitles.COVERAGE, key: 'coverage' },
            { name: RESTOCKING.subTitles.STOCK_MAX, key: 'stock_max' },
            { name: RESTOCKING.subTitles.CONSIDERED_STOCK, key: 'considered_stock' },
            { name: RESTOCKING.subTitles.HAS_RESTOCKING, key: 'has_restocking' },
        ])

        return card
    }

    static restockingCard() {
        const { SOLICITATION, DC_OVERVIEW, BRANCH_OVERVIEW, DYNAMIC_MINIMUM } = this.cardTitles().RESTOCKING_MANAGEMENT
        const card = new Model('Gestão da Rep. Dinâmica')

        card.addItem('parameters', SOLICITATION.name, [
            { name: SOLICITATION.subTitles.SHOWCASE_ITEMS, key: 'showcase_items' },
            { name: SOLICITATION.subTitles.STACK_ITEMS, key: 'stack_items' },
            { name: SOLICITATION.subTitles.COVERAGE, key: 'coverage' },
            { name: SOLICITATION.subTitles.STOCK_MAX, key: 'stock_max' },
        ])

        card.addItem('dcOverview', DC_OVERVIEW.name, [
            { name: DC_OVERVIEW.subTitles.TOTAL_STOCK, key: 'total_stock' },
            { name: DC_OVERVIEW.subTitles.RESERVED_STOCK, key: 'reserved_stock' },
            { name: DC_OVERVIEW.subTitles.NET_STOCK, key: 'net_stock' },
            { name: DC_OVERVIEW.subTitles.TOTAL_STOCK, key: 'total_solicitation' },
            { name: DC_OVERVIEW.subTitles.RESERVED_STOCK, key: 'reserved_solicitation' },
            { name: DC_OVERVIEW.subTitles.NET_STOCK, key: 'net_solicitation' },
        ])

        card.addItem('branchOverview', BRANCH_OVERVIEW.name, [
            { name: BRANCH_OVERVIEW.subTitles.TOTAL_STOCK, key: 'total_stock' },
            { name: BRANCH_OVERVIEW.subTitles.TOTAL_TRAFFIC, key: 'total_traffic' },
            { name: BRANCH_OVERVIEW.subTitles.TOTAL_SOLICITATION, key: 'total_solicitation' },
            { name: BRANCH_OVERVIEW.subTitles.RESERVED_STOCK, key: 'reserved_value' },
        ])

        card.addItem('dynamicMinimum', DYNAMIC_MINIMUM.name, [
            { name: DYNAMIC_MINIMUM.subTitles.QUANTITY, key: 'considered_stock' },
            { name: DYNAMIC_MINIMUM.subTitles.DAYS, key: 'considered_stock_coverage' },
        ])

        return card
    }
}

export default Solicitation

export { Solicitation }
